import { SelectionMode } from "@fluentui/react";
import { DataLoadMode, IObjectPickerModalOptions } from "@cayo/shared/api/types/schema";

// AdditionalColumns: "[]"
// AdditionalReadProperties: ""
// CommandId: "00000000-0000-0000-0000-000000000008"
// ExtId: "PM.Ext.AD"
// MaxResult: "20"
// ProhibitedSearchScopes: "[]"
// SearchText: ""
// SelectedIds: ""
// SelectedSearchScope: ""
// Tag: "recipients"
// TargetFormPropertyId: "MemberOfData"
// ViewID: "c95a5307-efaf-47d3-a180-9b1e36570d9d"
// TargetFormActionCommandId: "b5473710-fd9d-4c1d-922d-9f6ce362a22a"

const searchScopes = [
  {
    name: "AD Groups",
    columns: [
      {
        displayName: "Name",
        key: "Name",
        fieldName: "Name",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Email",
        key: "Email",
        fieldName: "Email",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Display Name",
        key: "DisplayName",
        fieldName: "DisplayName",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Description",
        key: "Description",
        fieldName: "Description",
        columnActionsMode: "disabled",
      },
      {
        displayName: "GroupT ype",
        key: "CayoGroupType",
        fieldName: "CayoGroupType",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Parent OU",
        key: "ParentOU",
        fieldName: "ParentOU",
        columnActionsMode: "disabled",
      },
    ],
    path: "/v1.0/objectpickers/00000000-0000-0000-0000-000000000008/execute2",
    body: {
      parameters: [
        {
          name: "CayoTargetFormActionCommandId",
          value: "b5473710-fd9d-4c1d-922d-9f6ce362a22a",
        },
        {
          name: "CayoTargetFormPropertyId",
          value: "MemberOfData",
        },
        {
          name: "CayoWebViewId",
          value: "c95a5307-efaf-47d3-a180-9b1e36570d9d",
        },
        {
          name: "CayoWebMaxResults",
          value: "20",
        },
      ],
    },
  },
];

const modalOptions: IObjectPickerModalOptions = {
  title: "Select Object",
  description: "",
  dataLoadMode: DataLoadMode.OnSearch,
  selectionMode: SelectionMode.multiple,
};

export const apiMocks = {
  searchScopes,
  modalOptions,
};
